import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { CustomPropertyCommandHandlerResolver } from '../../service/command/custom-property-command-handler-resolver.service';
import { CustomProperty } from '../../model/custom-property';
import { CustomPropertyService } from '../../service/data/custom-property.service';

@Component({
    selector: 'app-custom-property-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [CustomPropertyCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomPropertyManagerComponent extends MultiselectObjectManagerComponentBase<CustomProperty> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: CustomPropertyService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: CustomPropertyCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('CustomProperty');
    this.title = 'CUSTOM_PROPERTY.LIST_HEADER';
    this.preferencesKey = 'rent.custom-property.list';
  }
}
